var collapsible_list_component_rtlignore_default = {
  "ltr": "qJrqT",
  "rtl": "BpK4n",
  "iconContainer": "H3ysy",
  "icon": "ea-mF",
  "isExpanded": "tWzaz",
  "listDimensions": "M65k-"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
